import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, VIEW } from "const"
import { StateType, hasAccess, hasProjectAccess } from "client/utils"
import {
    PRM_CC_LIBRARY,
    StoreType,
    CcLibraryItemProps,
    LoadCcLibraryItemById,
    LoadCcLibrarySetById,
    IsOwnerCcLibrarySet,
    IsOwnerCcLibraryItem,
    setCcLibraryItemView,
    setCcLibrarySetView,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import AccessDenied from "client/parts/accessDenied"
import NotFound from "client/parts/notFound"
import Form from "./form"


const ItemView = ({
    setId,
    itemId,
}: CcLibraryItemProps) => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const item = useSelector((state: StoreType) => state.ccLibraryItem.itemView)
    const set = useSelector((state: StoreType) => state.ccLibrarySet.setView)
    const reloadView = useSelector((state: StoreType) => state.ccLibraryItem.reloadView)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!reloadView) return
        setLoadState(PENDING)
        const promiseArray: Promise<any>[] = [
            LoadCcLibraryItemById(itemId, setId).then((res) => {
                dispatch(setCcLibraryItemView(res))
            }),
        ]
        if (!set || set.id !== setId) {
            LoadCcLibrarySetById(setId, userData.accountId, project.id).then((res) => {
                dispatch(setCcLibrarySetView(res))
            })
        }
        Promise.all(promiseArray).then(() => {
            setLoadState(IDLE)
        })
    }, [reloadView])

    const viewAccess = !project.id
        ? hasAccess(PRM_CC_LIBRARY, VIEW)
        : hasProjectAccess(PRM_CC_LIBRARY, VIEW)

    const isSetOwner = IsOwnerCcLibrarySet(project.id, set, userData)
    const isItemOwner = IsOwnerCcLibraryItem(project.id, item, userData)

    const allowedToView = viewAccess || isSetOwner || isItemOwner

    if (!allowedToView) return <AccessDenied />
    if (!item || !set) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{`${lang.viewCompliantItem} # ${item.id || ""}`}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }
                <Form />
            </PageContent>
        </Container>
    )
}
export default ItemView
